import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SharedThemeModule } from "@kno2/layout/theme";
import { InfoPopoverComponent } from "@kno2/shared/info-popover";
import { InputMaskModule } from "@ngneat/input-mask";
import { NgxDropzoneModule } from "ngx-dropzone";
import { NgPipesModule } from "ngx-pipes";
import { FeatureToggleDirective } from "../shared/features/feature-toggle.directive";
import { FileDropzoneComponent } from "../shared/file-dropzone/file-dropzone.component";
import { AlertComponent } from "./alert/alert.component";
import { ControlPanelComponent } from "./components/control-panel/control-panel.component";
import { ControlPanelItemBodyDirective } from "./components/control-panel/item-body/control-panel-item-body.directive";
import { BottomPaneComponent } from "./components/vertical-split-container/bottom-pane/bottom-pane.component";
import { TopPaneComponent } from "./components/vertical-split-container/top-pane/top-pane.component";
import { VerticalSplitPaneComponent } from "./components/vertical-split-container/vertical-split-pane.component";
import { AppendFileExtensionDirective } from "./directives/append-file-extension/append-file-extension.directive";
import { AutoFocusDirective } from "./directives/autofocus/auto-focus.directive";
import { FileDropzoneOverlayDirective } from "./directives/file-dropzone-overlay.directive";
import { Kno2LoadingOverlayDirective } from "./directives/loading-overlay/loading-overlay.directive";
import { TooltipDirective } from "./directives/tooltip/tooltip.directive";
import { FileSizePipe } from "./pipes/file-size.pipe";
import { GenderPipe } from "./pipes/gender.pipe";
import { IsoToDatePipe } from "./pipes/iso-to-date.pipe";
import { ResultCountPipe } from "./pipes/result-count.pipe";
import { ResultStatusPipe } from "./pipes/result-status.pipe";
import { TextNormalizationPipe } from "./pipes/text-normalization.pipe";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedThemeModule,
        FormsModule,
        ReactiveFormsModule,
        NgPipesModule,
        InputMaskModule,
        NgxDropzoneModule,
        InfoPopoverComponent,
        TooltipDirective,
        Kno2LoadingOverlayDirective,
        AlertComponent
    ],
    declarations: [
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FeatureToggleDirective,
        AppendFileExtensionDirective,
        AutoFocusDirective,
        FileDropzoneComponent,
        ControlPanelItemBodyDirective,
        ControlPanelComponent,
        FileDropzoneOverlayDirective
    ],
    exports: [
        NgPipesModule,
        CommonModule,
        SharedThemeModule,
        FileSizePipe,
        GenderPipe,
        IsoToDatePipe,
        ResultCountPipe,
        ResultStatusPipe,
        TextNormalizationPipe,
        BottomPaneComponent,
        TopPaneComponent,
        VerticalSplitPaneComponent,
        FeatureToggleDirective,
        AppendFileExtensionDirective,
        AlertComponent,
        InputMaskModule,
        AutoFocusDirective,
        FileDropzoneComponent,
        ControlPanelComponent,
        FileDropzoneOverlayDirective,
        InfoPopoverComponent,
        TooltipDirective,
        Kno2LoadingOverlayDirective
    ]
})
export class SharedUiCommonModule {}
